import { CRM } from "@/components/atomic-crm/root/CRM";

/**
 * Application entry point
 *
 * Customize Atomic CRM by passing props to the CRM component:
 *  - companySectors
 *  - darkTheme
 *  - dealCategories
 *  - dealPipelineStatuses
 *  - dealStages
 *  - lightTheme
 *  - darkModeLogo / lightModeLogo
 *  - noteStatuses
 *  - taskTypes
 *  - title
 * ... as well as all the props accepted by shadcn-admin-kit's <Admin> component.
 *
 * Logos must be an imported asset, an absolute URL, or a data URI — never a
 * route-relative path like "./img/logo.png", which breaks on nested routes.
 *
 * @example
 * import logoDark from "./logo-dark.svg";
 * import logoLight from "./logo-light.svg";
 *
 * const App = () => (
 *    <CRM
 *       darkModeLogo={logoDark}
 *       lightModeLogo={logoLight}
 *       title="Acme CRM"
 *    />
 * );
 */
// Per-tenant branding (set in the tenant's .env.production.local; files live in that tenant's public/brand/).
const brand = {
  ...(import.meta.env.VITE_LOGO_DARK && {
    darkModeLogo: import.meta.env.VITE_LOGO_DARK,
  }),
  ...(import.meta.env.VITE_LOGO_LIGHT && {
    lightModeLogo: import.meta.env.VITE_LOGO_LIGHT,
  }),
};

const App = () => <CRM {...brand} />;

export default App;
